import { useRef } from 'react';
import { AppVersionData, getAppVersionData } from '../../app-version/version-utils';
import { ApplicationLoggingAppName, ApplicationLoggingData } from '@idu-nightlife/nightlife-utils';

export function resolveLoggingData({
  appVersionData,
  appName,
}: {
  appVersionData: AppVersionData;
  appName: ApplicationLoggingAppName;
}): ApplicationLoggingData {
  return {
    appName,
    appWebVersion: appVersionData.runningVersion,
    appNativeVersion: appVersionData.nativeVersion,
    webViewPath: appVersionData.webViewPath,
    isNative: appVersionData.isNative,
  };
}

export const useCachedAppVersionData = () => {
  const appVersionDataPromiseRef = useRef<ReturnType<typeof getAppVersionData> | null>(null);

  return async () => {
    if (!appVersionDataPromiseRef.current) {
      appVersionDataPromiseRef.current = getAppVersionData().catch((error) => {
        console.error('Failed to get app version data for request logging', error);
        return {
          runningVersion: 'unknown',
          nativeVersion: '',
          webViewPath: '',
          otaAppliedVersion: null,
          isNative: false,
          appName: 'unknown',
        };
      });
    }

    return appVersionDataPromiseRef.current;
  };
};
